import React from 'react';
import { useAuthService } from '@trp-ta-nitro/auth-react';

import { InitializedContextCreator } from './actions/ContextCreators';
import App from './components/App';
import { featureFlags } from './feature';
import { log } from './Utils';

const InitializeReducer = (state, action) => {
    switch (action.type) {
        case 'DEV':
            return {
                ...state,
                env: 'DEV',
                development: true, // should be true
                isLoading: action.isLoading,
                domainName: action.domainName,
                trpUserData: action.trpUserData,
                featureFlags: action.featureFlags,
            };
        case 'STAGE':
            return {
                ...state,
                env: 'STAGE',
                development: true, // should be true
                isLoading: action.isLoading,
                domainName: action.domainName,
                trpUserData: action.trpUserData,
                featureFlags: action.featureFlags,
            };
        case 'PROD':
            return {
                ...state,
                env: 'PROD',
                production: true, // should be true
                isLoading: action.isLoading,
                domainName: action.domainName,
                trpUserData: action.trpUserData,
                featureFlags: action.featureFlags,
            };
        case 'FAIL_TO_LOAD_CONFIGURATIONS':
            return { ...state };
        default:
            throw new Error();
    }
};

const Initialize = (definedDomain, definedTRPUserState, authInfo) => {
    const [domain, setDomain] = React.useState(definedDomain);
    const [cancelled, setCancelled] = React.useState(false);
    const [features, setFeatures] = React.useState(featureFlags(definedDomain));
    const isDevDomain = domain === 'dev';
    const isStageDomain = domain === 'stage';

    log(console.log('isdEV', isDevDomain));

    const [indexState, dispatch] = React.useReducer(InitializeReducer, {
        development: false,
        production: false,
        isLoading: true,
        domainName: '',
        env: '',
        trpUserData: {},
        featureFlags: {},
    });
    window.fps.env = features;
    log(console.log('domain', domain));

    const getConfiguations = React.useCallback(async () => {
        try {
            const hostName = () =>
                Promise.resolve(window ? window.location.hostname.toLowerCase().indexOf(domain) !== -1 : false);

            const host = await hostName();

            const { lastAuthState } = authInfo;
            const updatedProps = {
                ...definedTRPUserState,
                userEntitlements: lastAuthState.entitlements,
                userId: lastAuthState.userId,
            };
            log(console.log('host', host));
            if (!cancelled) {
                if (isDevDomain) {
                    setFeatures(featureFlags('DEV'));
                    dispatch({
                        type: 'DEV',
                        isLoading: false,
                        domainName: domain,
                        trpUserData: updatedProps,
                        featureFlags: features,
                    });
                } else if (isStageDomain) {
                    setFeatures(featureFlags('STAGE'));
                    dispatch({
                        type: 'STAGE',
                        isLoading: false,
                        domainName: domain,
                        trpUserData: updatedProps,
                        featureFlags: features,
                    });
                } else {
                    setFeatures(featureFlags('PROD'));
                    dispatch({
                        type: 'PROD',
                        isLoading: false,
                        domainName: domain,
                        trpUserData: updatedProps,
                        featureFlags: features,
                    });
                }
            }
        } catch (error) {
            if (!cancelled) {
                dispatch({ type: 'FAIL_TO_LOAD_CONFIGURATIONS', error });
            }
        }
    }, [domain, features, definedTRPUserState, cancelled, isDevDomain, isStageDomain, authInfo]);

    React.useEffect(() => {
        getConfiguations();
        return () => {
            setCancelled(true);
        };
    }, []);

    return [indexState, setDomain, definedTRPUserState];
};

export default function MGPWrapper(props) {
    const env = props?.applicationConfig?.environment;
    const authServiceInfo = useAuthService();
    const [indexState] = Initialize(env, props, authServiceInfo);

    return (
        <InitializedContextCreator.Provider value={{ indexState }}>
            <div> {!indexState.isLoading ? <App /> : null}</div>
        </InitializedContextCreator.Provider>
    );
}
